import GenericQrCode from './generic-qr-code';
import { useSelector } from 'react-redux';
import getImage from 'helpers/getImage';
import './loyalty-card-preview.css';
import loyaltyQr from '../../assets/images/loyalty-qr.png';

const LoyaltyCardPreview = ({
  mainTextColor,
  labelColor,
  bgColor,
  selectedImageTheme,
  customReferralId,
  customName,
  customPoints,
}) => {
  const { storeConfig } = useSelector((state) => state.layoutReducer);
  const { logo, logoPath } = storeConfig || {};
  const storeLogo = getImage(logoPath || logo);

  // Use custom values if provided, otherwise use default values
  const referralId = customReferralId || '1231 065 366';
  const displayName = customName
    ? customName.toUpperCase()
    : 'JOHNNY APPLESEED';
  const pointsBalance = customPoints !== undefined ? customPoints : 7584;

  return (
    <div
      className='loyalty-card-preview bg-gray-400'
      style={{
        backgroundColor: bgColor,
        border: '0.72px solid rgba(255, 255, 255, 0.2)',
      }}
    >
      <div className='loyalty-preview-header flex justify-between w-full'>
        <div className='self-center'>
          {storeLogo && (
            <img
              className='max-h-[40px] w-auto max-w-[100px]'
              src={storeLogo}
              alt='logo'
            />
          )}
        </div>
        <div className='loyalty-preview-referral-container'>
          <div
            className='text-right font-normal text-[10px]'
            style={{ color: labelColor }}
          >
            {referralId}
          </div>
        </div>
      </div>
      <div className='loyalty-preview-card-design w-full'>
        {selectedImageTheme && (
          <img
            className='w-full h-full object-cover'
            src={selectedImageTheme}
            alt='logo'
          />
        )}
      </div>
      <div className='loyalty-preview-secondary px-2 py-2 flex'>
        <div className='flex-1'>
          <div className='text-[7px]' style={{ color: labelColor }}>
            NAME
          </div>
          <div style={{ color: mainTextColor }} className='font-normal font-xs'>
            {displayName}
          </div>
        </div>
        <div>
          <div className='text-[7px]' style={{ color: labelColor }}>
            POINTS BALANCE
          </div>
          <div
            style={{ color: mainTextColor }}
            className='text-right font-normal font-xs'
          >
            {pointsBalance.toLocaleString()}
          </div>
        </div>
      </div>
      <div className='loyalty-preview-qrcode mt-6 pb-8'>
        <div className='flex justify-center'>
          <img
            src={loyaltyQr}
            alt='QR Code'
            className='rounded-[5.8px]'
            style={{ width: '97px', height: '97px' }}
          />
        </div>
      </div>
    </div>
  );
};

export default LoyaltyCardPreview;
